import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const ElasticsearchIntegration = React.lazy(() => import("./ElasticsearchIntegration"));

interface ElasticsearchIntegrationLazyProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function ElasticsearchIntegrationLazy(props: ElasticsearchIntegrationLazyProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <ElasticsearchIntegration {...props} />
    </Suspense>
  );
}
